export const LOGO_URL =
  "/logos/magee-enterprises-logo.png";

export const HERO_IMAGE =
  "/home/b2b-women-conference.jpg";

export const IMAGES = {
  hero:
    "/home/b2b-women-conference.jpg",
  strategic:
    "/testimonials/person-9.webp",
  tech:
    "https://images.unsplash.com/photo-1510511233900-1982d92bd835?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwyfHxldmVudCUyMHRlY2hub2xvZ3klMjBhdiUyMHByb2R1Y3Rpb258ZW58MHx8fHwxNzg0MzkwODYxfDA&ixlib=rb-4.1.0&q=85",
  gala:
    "https://images.unsplash.com/photo-1700514077430-3659e38eb5e7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwyfHxoaWdoJTIwZW5kJTIwY29ycG9yYXRlJTIwZ2FsYSUyMGV2ZW50fGVufDB8fHx8MTc4NDM5MDg2MXww&ixlib=rb-4.1.0&q=85",
  conference:
    "https://images.pexels.com/photos/6949886/pexels-photo-6949886.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  control:
    "https://images.unsplash.com/photo-1766019463451-04e0b1269f37?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHw0fHxldmVudCUyMG1hbmFnZW1lbnQlMjBwbGFubmluZyUyMGRlc2t8ZW58MHx8fHwxNzg0MzkwODYyfDA&ixlib=rb-4.1.0&q=85",
};

export const NAV_LINKS = [
  {
    label: "Home",
    id: "home",
    to: "/",
    children: [
      { label: "Overview", to: "/#strategy", body: "Our strategy." },
      { label: "Leadership", to: "/leadership", body: "Meet Sir Dion Magee, CEO." },
    ],
  },
  {
    label: "Solutions",
    id: "services",
    to: "/services",
    children: [
      { label: "All Solutions", to: "/services", body: "Our services, side by side." },
      { label: "Strategic Meeting Management", to: "/services#chapter-01", body: "Flagship concierge · full-service." },
      { label: "Event Tech Concierge", to: "/services/event-tech", body: "Registration, mobile, hybrid, data — 11 modules." },
      { label: "M.E. DMC", to: "/services/me-dmc", body: "Destination Management Company — local logistics, in-market execution." },
      { label: "VIP & Film", to: "/services/vip-film", body: "Destination management for tours & VIP.", nested: true },
      { label: "Site Selection & Sourcing", to: "/services/site-selection", body: "Venues, hotels, and destinations — hand-picked." },
      { label: "B2B Services", to: "/b2b-services", body: "Formation, trademark, brand launch & ops support." },
    ],
  },
  { label: "Event Tech", id: "event-tech", to: "/services/event-tech" },
  { label: "Portfolio", id: "portfolio", to: "/about#portfolio" },
  { label: "Contact", id: "contact", to: "/contact" },
];
